import { datadogRum } from "@datadog/browser-rum";
var addDataDogUserAction = function(name, context) {
    datadogRum.addAction(name, context);
};
export { addDataDogUserAction };
